import { Button } from '@/components/ui/button'
import { createFileRoute, Link } from '@tanstack/react-router'
import { PenTool, Sparkles } from 'lucide-react'

export const Route = createFileRoute('/_dashboard/write/')({
  component: WritePage,
})

function WritePage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-4xl">
        <div className="mb-12 space-y-6 text-center">
          <h1 className="text-4xl font-bold">Create New Article</h1>
          <p className="mx-auto max-w-2xl text-xl text-muted-foreground">
            Choose how you'd like to create your next article. Use AI assistance
            for quick generation or write manually for full creative control.
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-2">
          {/* AI Generation Option */}
          <Link
            to="/write/ai"
            className="p-8 rounded-lg border transition-shadow cursor-pointer bg-card hover:shadow-lg group text-left block"
          >
            <div className="space-y-4 text-center">
              <div className="flex justify-center">
                <div className="p-4 rounded-full transition-colors">
                  <Sparkles className="w-12 h-12 text-primary" />
                </div>
              </div>
              <h2 className="text-2xl font-semibold">AI Article Writer</h2>
              <p className="text-muted-foreground">
                Generate articles quickly with AI assistance. Provide a topic
                and let our AI create well-structured, engaging content for you.
              </p>
              <div className="pt-4">
                <Button size="lg" className="w-full">
                  <Sparkles className="w-4 h-4" />
                  Generate with AI
                </Button>
              </div>
            </div>
          </Link>

          {/* Manual Writing Option */}
          <Link
            to="/write/manual"
            className="p-8 rounded-lg border transition-shadow cursor-pointer bg-card hover:shadow-lg group text-left block"
          >
            <div className="space-y-4 text-center">
              <div className="flex justify-center">
                <div className="p-4 rounded-full transition-colors">
                  <PenTool className="w-12 h-12 text-primary" />
                </div>
              </div>
              <h2 className="text-2xl font-semibold">Manual Editor</h2>
              <p className="text-muted-foreground">
                Write your article from scratch with our rich text editor.
                Perfect for when you want full creative control over your
                content.
              </p>
              <div className="pt-4">
                <Button size="lg" className="w-full">
                  <PenTool className="w-4 h-4" />
                  Write Manually
                </Button>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
